import sanitizeHtml from "sanitize-html";

// target="_blank" without rel="noopener noreferrer" lets the opened page
// access window.opener (tab-napping). CMS editors are trusted, but this is
// cheap defence-in-depth - force it on every link regardless of what's set.
const forceSafeLinkRel = sanitizeHtml.simpleTransform(
  "a",
  { rel: "noopener noreferrer" },
  true,
);

// Inline-only: no p/br/div/headings/lists, so multi-line markup from the
// CMS editor collapses onto a single line instead of growing the banner's
// height (which Header/Page rely on being stable - see GlobalBanner).
export const sanitizeBannerHtmlOptions = {
  allowedTags: ["b", "strong", "i", "em", "u", "span", "a"],
  allowedAttributes: {
    a: ["href", "target", "rel"],
  },
  transformTags: {
    a: forceSafeLinkRel,
  },
};

export const sanitizeHtmlOptions = {
  allowedTags: sanitizeHtml.defaults.allowedTags.concat(["img"]),
  nonTextTags: ["script", "style", "textarea", "option", "noscript", "xmp"],
  allowedAttributes: {
    a: ["href", "name", "target", "rel"],
    p: ["style"],
    table: ["border"],
    td: ["style"],
    tr: ["style"],
    img: ["src", "alt", "title"],
  },
  transformTags: {
    a: forceSafeLinkRel,
  },
  allowedStyles: {
    "*": {
      // Match HEX and RGB
      color: [
        /^#(0x)?[0-9a-f]+$/i,
        /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
      ],
      "text-align": [/^left$/, /^right$/, /^center$/],
      // Match any number with px, em, or %
      "font-size": [/^\d+(?:px|em|%)$/],
      "vertical-align": [/^top$/, /^bottom$/, /^center$/],
    },
  },
};
